import { Controller } from "@hotwired/stimulus"

// Visionneuse plein écran pour les captures d'écran (flèches ← → pour naviguer).
export default class extends Controller {
  static targets = ["dialog", "image", "caption", "download"]

  open(event) {
    const trigger = event.currentTarget
    this.items = Array.from(trigger.closest(".gallery")?.querySelectorAll("[data-lightbox-src]") || [trigger])
    this.index = this.items.indexOf(trigger)
    this.show()
    this.dialogTarget.showModal()
  }

  show() {
    const item = this.items[this.index]
    this.imageTarget.src = item.dataset.lightboxSrc
    this.imageTarget.alt = item.dataset.lightboxCaption || ""
    this.downloadTarget.href = item.dataset.lightboxSrc
    const counter = this.items.length > 1 ? ` · ${this.index + 1}/${this.items.length}` : ""
    this.captionTarget.textContent = `${item.dataset.lightboxCaption || ""}${counter}`
  }

  prev() { if (this.items?.length > 1) { this.index = (this.index - 1 + this.items.length) % this.items.length; this.show() } }
  next() { if (this.items?.length > 1) { this.index = (this.index + 1) % this.items.length; this.show() } }

  close() { this.dialogTarget.close() }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
